import { Radio } from 'antd';
import PropTypes from 'prop-types';
import React, { memo } from 'react';

const DynamicFieldRadioButton = ({ value, onChange, options, ...props }) => {
  return (
    <Radio.Group
      value={value}
      onChange={onChange}
      options={options}
      optionType="button"
      buttonStyle="solid"
      {...props}
    />
  );
};

DynamicFieldRadioButton.propTypes = {
  value: PropTypes.any,
  options: PropTypes.array,
  onChange: PropTypes.func,
};

DynamicFieldRadioButton.defaultProps = {};

export default memo(DynamicFieldRadioButton);
